import { FormGroup } from '@angular/forms';
import { IProduct } from '@app/models/product.interface';
import { createAction, props } from '@ngrx/store';
import { ILocation } from '@app/models/location.interface';

export const loadCategories = createAction(
  '[Organization] Load Organizations'
);

export const loadCategoriesSuccess = createAction(
  '[Organization] Load Organizations Success',
  props<{ categories: any }>()
);

export const loadCategoriesFailure = createAction(
  '[Organization] Load Organizations Failure',
  props<{ error: any }>()
);

export const loadAreas = createAction(
  '[Organization] Load Areas'
);

export const loadAreasSuccess = createAction(
  '[Organization] Load Areas Success',
  props<{ areas: any }>()
);

export const loadAreasFailure = createAction(
  '[Organization] Load Areas Failure',
  props<{ error: any }>()
);

export const saveCategory = createAction(
  '[Organization] Save Category',
  props<{form: FormGroup }>()
);

export const saveCategorySuccess = createAction(
  '[Organization] Save Category Success',
  props<{ category: any }>()
);

export const saveCategoryFailure = createAction(
  '[Organization] Save Category Failure',
  props<{ error: any }>()
);

export const updateCategory = createAction(
  '[Organization] Update Category',
  props<{ form: FormGroup, prdCatID: number  }>()
);

export const updateCategorySuccess = createAction(
  '[Organization] Update Category Success',
  props<{ category: any, prdCatID }>()
);

export const updateCategoryFailure = createAction(
  '[Organization] Update Category Failure',
  props<{ error: any }>()
);

export const addArea = createAction(
  '[Organization] Add Area',
  props<{ form: FormGroup }>()
);

export const addAreaSuccess = createAction(
  '[Organization] Add Area Success',
  props<{ area: any }>()
);

export const addAreaFailure = createAction(
  '[Organization] Add Area Failure',
  props<{ error: any }>()
);

export const updateArea = createAction(
  '[Organization] Update Area',
  props<{ form: FormGroup, prdAreaID: number}>()
);

export const updateAreaSuccess = createAction(
  '[Organization] Update Area Success',
  props<{ area: any }>()
);

export const updateAreaFailure = createAction(
  '[Organization] Update Area Failure',
  props<{ error: any }>()
);

export const deleteCategory = createAction(
  '[Organization] Delete Category'
);

export const deleteCategorySuccess = createAction(
  '[Organization] Delete Category Success',
  props<{ category: any }>()
);

export const selectFirstRow = createAction(
  '[Organization] Select First Row After Delete',
);

export const selectFirstRowSuccess = createAction(
  '[Organization] Select First Row After Delete Success',
);

export const deleteArea = createAction(
  '[Organization] Delete Area'
);

export const deleteAreaSuccess = createAction(
  '[Organization] Delete Area Success',
  props<{ prdAreaID: any }>()
);

export const setCurrentItem = createAction(
  '[Organization] Set Current Item',
  props<{ item: any }>()
);

export const loadAllSettings = createAction(
  '[Organization] Load Settings'
);

export const loadAllSettingsSuccess = createAction(
  '[Organization] Load Settings Success',
  props<any>()
);

export const loadAllSettingsFailure = createAction(
  '[Organization] Load Settings Failure',
  props<{ error: string }>()
);

export const checkArea = createAction(
  '[Organization] Check Area',
  props<{prdAreaID: number, checked: boolean}>()
);

export const setPsa = createAction(
  '[Organization] Set PSA',
  props<any>()
);

export const resetPsa = createAction(
  '[Organization] Reset PSA'
);

export const setSection = createAction(
  '[Organization] Set Section',
  props<{section: number}>()
);

/**
 * Master Sorter
 */

export const loadMasterSortCategories = createAction(
  '[Organization] Load Master Sort Categories',
  props<{ prdCatID: number }>()
)

export const loadMasterSortCategoriesSuccess = createAction(
  '[Organization] Load Master Sort Categories Success',
  props<{ data: any }>()
);

export const removeFromMasterSortCategories = createAction(
  '[Organization] Remove From Master Sort Categories',
  props<{ product: IProduct, id : number }>()
)

export const removeFromMasterSortCategoriesSuccess = createAction(
  '[Organization] Remove From Master Sort Categories Success',
  props<{ product: IProduct }>()
);

export const addFromMasterSortCategories = createAction(
  '[Organization] Add From Master Sort Categories',
  props<{ product: IProduct }>()
)

export const addFromMasterSortCategoriesSuccess = createAction(
  '[Organization] Add From Master Sort Categories Success',
  props<{ product: IProduct }>()
);

export const loadMasterSortAreas = createAction(
  '[Organization] Load Master Sort Areas',
  props<{ prdAreaID: number}>()
);

export const loadMasterSortAreasSuccess = createAction(
  '[Organization] Load Master Sort Areas Success',
  props<{ data: any }>()
);

export const removeFromMasterSortAreas = createAction(
  '[Organization] Remove From Master Sort Areas',
  props<{ product: IProduct }>()
)

export const removeFromMasterSortAreasSuccess = createAction(
  '[Organization] Remove From Master Sort Areas Success',
  props<{ product: IProduct }>()
);

export const addFromMasterSortAreas = createAction(
  '[Organization] Add From Master Sort Areas',
  props<{ product: IProduct }>()
)

export const addFromMasterSortAreasSuccess = createAction(
  '[Organization] Add From Master Sort Areas Success',
  props<{ product: IProduct }>()
);

export const addAllFromMasterSortAreas = createAction(
  '[Organization] Add All From Master Sort Areas',
  props<{ products: any, prdCatID: number }>()
)

export const addAllFromMasterSortAreasSuccess = createAction(
  '[Organization] Add All From Master Sort Areas Success',
  props<{ products: IProduct, prdCatID: any }>()
);

export const addUncategorizedFromMasterSortAreas = createAction(
  '[Organization] Add Uncategorized From Master Sort Areas',
  props<{ products: any }>()
)

export const addUncategorizedFromMasterSortAreasSuccess = createAction(
  '[Organization] Add Uncategorized From Master Sort Areas Success',
  props<{ products: IProduct }>()
);

export const setQueryIn = createAction(
  '[Organization] Set Query in',
  props<{ query: any }>()
)

export const setQueryNotInArea = createAction(
  '[Organization] Set Query Not in Area',
  props<{ query: any }>()
)

export const setQueryNotInCategory = createAction(
  '[Organization] Set Query Not in Category',
  props<{ query: any }>()
)

export const resetQueryNotIn = createAction(
  '[Organization] Reset Query Not In',
)

export const resetQueryIn = createAction(
  '[Organization] Reset Query In',
)

export const resetQueryNotInArea = createAction(
  '[Organization] Reset Query Not in Area',
)

export const resetQueryNotInCategory = createAction(
  '[Organization] Reset Query Not In Category',
)

export const setNoInCatPos = createAction(
  '[Organization] Set Right Panel Position',
  props<{ posName: string }>()
)

export const setInCatPos = createAction(
  '[Organization] Set Left Panel Position',
  props<{ posName: string }>()
)

export const sortAreas = createAction(
  '[Organization] Sort Areas',
  props<{ products: IProduct[], area: number }>()
)

export const sortAreasSuccess = createAction(
  '[Organization] Sort Areas Success'
);

export const sortAreasFailure = createAction(
  '[Organization] Sort Areas Failure',
  props<{ error: any }>()
)

export const sortCategories = createAction(
  '[Organization] Sort Categories',
  props<{ products: IProduct[] }>()
)

export const sortCategoriesSuccess = createAction(
  '[Organization] Sort Categories Success'
);

export const sortCategoriesFailure = createAction(
  '[Organization] Sort Categories Failure',
  props<{ error: any }>()
)

export const sortCategoryByName = createAction(
  '[Organization] Sort Categories By Name',
  props<{ prdCatID: number }>()
)

export const sortCategoryByNameSuccess = createAction(
  '[Organization] Sort Categories By Name Success',
  props<{ inCat: IProduct[] }>()
);

export const sortCategoryByNameFailure = createAction(
  '[Organization] Sort Categories By Name Failure',
  props<{ error: any }>()
)

export const sortAreaByName = createAction(
  '[Organization] Sort Area By Name',
  props<{ prdAreaID: number }>()
)

export const sortAreaByNameSuccess = createAction(
  '[Organization] Sort Area By Name Success'
);

export const sortAreaByNameFailure = createAction(
  '[Organization] Sort Area By Name Failure',
  props<{ error: any }>()
)

export const addToCount = createAction(
  '[Organization] Add to Count',
  props<{ 
    pcmItemQty: number,
    product: IProduct,
    prdCatID: number
   }>()
)

export const doneToCount = createAction(
  '[Organization] Done to Count',
  props<{ pcmItemQty: any }>()
)

/* start multilocations actions */
export const loadLocations = createAction(
  '[Location] Load Locations'
);

export const loadLocationsSuccess = createAction(
  '[Location] Load Locations Success',
  props<{ locations: ILocation[], total: number }>()
);

export const loadLocationsFailure = createAction(
  '[Location] Load Locations Failure',
  props<{ error: any }>()
);

export const sortLocations = createAction(
  '[Location] Sort Locations',
  props<{ sort: any, direction: any }>()
)

export const incrementPage = createAction(
  '[Location] Increment Pagination',
  props<{ currentPage: any }>()
);

export const incrementPageSuccess = createAction(
  '[Location] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Location] Decrement Pagination'
);

export const saveLocation = createAction(
  '[Location] Save Location',
  props<{ location: any }>()
)

export const saveLocationSuccess = createAction(
  '[Location] Save Location Success',
  props<{ location: any }>()
)

export const saveLocationFailure = createAction(
  '[Location] Save Location Failure',
  props<{error: any}>()
)

export const deleteLocation = createAction(
  '[Location] Delete Location',
  props<{
    id: any
  }>()
)

export const deleteLocationSuccess = createAction(
  '[Location] Delete Location Success',
  props<{ id: any }>()
)

export const deleteLocationFailure = createAction(
  '[Location] Delete Location Failure'
)

export const noDeleteLocationSuccess = createAction(
  '[Location] No Delete Location Success',
  props<{ id: any }>()
)

export const loadLocation = createAction(
  '[Location] Load Location',
  props<{id: number }>()
);

export const loadLocationSuccess = createAction(
  '[Location] Load Location Success',
  props<{ location: any }>()
);

export const loadLocationFailure = createAction(
  '[Location] Load Location Failure',
  props<{ error: any }>()
);

export const updateLocation = createAction(
  '[Location] Update Location',
  props<{
    id: any, 
    location: any }>()
)

export const updateLocationSuccess = createAction(
  '[Location] Update Location Success',
  props<{ location: any }>()
)

export const updateLocationFailture = createAction(
  '[Location] Update Location Failure',
  props<{ error: any }>()
)

export const resetLocation = createAction(
  '[Location] Reset Location'
);

export const deleteLocationsShowErrorMessage = createAction(
  '[Error] Delete Location Show Error Message',
  props<{ id: number}>()
)

export const assignNewLocation = createAction(
  '[Location] Assign New Location',
  props<{ current_location: number, new_location: number }>()
)

/* end multilocations actions */